import { render, staticRenderFns } from "./ModalCarrierList.vue?vue&type=template&id=06f41874&scoped=true&"
import script from "./ModalCarrierList.vue?vue&type=script&lang=js&"
export * from "./ModalCarrierList.vue?vue&type=script&lang=js&"
import style0 from "./ModalCarrierList.vue?vue&type=style&index=0&id=06f41874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f41874",
  null
  
)

export default component.exports